// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1uSjE","inputDescription":"styles_inputDescription__1CB9V"};